import React, { useState } from 'react';
import { Modal, Card, Box, Stack } from '@mui/material';
import { StyledButton } from '../ui/StyledButton';

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    p: 4,
    minHeight: "400px",
    borderRadius: "6px",
};

const ViewRemark = ({ value }: { value: string }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <button
                onClick={handleOpen}
                style={{
                    padding: '10px 15px',
                    backgroundColor: '#000000',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                }}
            >
                View Remark
            </button>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>

                    <Stack
                        direction={"column"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        gap={"8px"}
                    >
                        <p id="modal-modal-description">{value}</p>

                        <StyledButton onClick={handleClose} variant="outlined">
                            Cancel
                        </StyledButton>
                    </Stack>
                </Box>
            </Modal>
        </div>
    );
};

export default ViewRemark;
